import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass({ header: true })
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.logoSrc,
        alt: "logo",
        class: _normalizeClass({ logo: true })
      }, null, 8, _hoisted_3)
    ])
  ]))
}